module.exports = __webpack_public_path__ + "media/pool.5e644299.mp4";